module.exports = __webpack_public_path__ + "static/media/BAP6.43ae7bd6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP6.png
 ** module id = 684
 ** module chunks = 0
 **/